import React from 'react'
import DatePicker from "react-multi-date-picker"
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import { dateHasPassed } from '../../functions/general'
const isEmptyDate = (value) => {
    if (value === null || value === undefined || value === '') return true
    return Number.isNaN(new Date(value).getTime())
}
export default function ReusableDatePicker({ type, width, 
    marginLeft, marginRight, marginTop, marginBottom,
    state, setState, required, disabled, Change,
    count, head, target,
    // For ReusableDatePicker
    range, minDate, maxDate, multiple, allowExceedMinMax, allowEmpty }) {
    let errorBorder = () => {
        if (allowExceedMinMax) return false
        if (multiple) {
            if (minDate) {
                for (let i = 0; i < state.length; i++) {
                    if (dateHasPassed(new Date(state[i]), minDate)) return true
                }
            }
            if (maxDate) {
                for (let i = 0; i < state.length; i++) {
                    if (dateHasPassed(maxDate, new Date(state[i]))) return true
                }
            }
        } else {
            if (minDate && dateHasPassed(new Date(state), minDate)) return true
            if (maxDate && dateHasPassed(maxDate, new Date(state))) return true
        }
        return false
    }
    const onChangeState = (value, callback) => {
        const single = multiple === undefined
        const currentCount = single
            ? (isEmptyDate(state) ? 0 : 1)
            : (Array.isArray(state) ? state.length : 0)
        const nextCount = single
            ? ((value === null || value === undefined) ? 0 : 1)
            : (Array.isArray(value) ? value.length : 0)
        // Keep the last date. Clearing it is what produced an invalid date.
        if (currentCount <= 1 && nextCount === 0) return false
        // Force re-render so as to ensure there is at least one date for multiple date
        if (multiple && value.length === 0 && !allowEmpty) value = [...state]
        // A cleared single date must stay null. Converting it with new Date()
        // produces an Invalid Date, and Date.toISOString() then throws.
        const cleared = single && allowEmpty && (value === null || value === undefined)
        if (cleared) value = null
        else if (single) value = new Date(value).setHours(0, 0, 0, 0)
        else value = value.map(v => new Date(v).setHours(0, 0, 0, 0))

        if (type === 'redux') setState(count, head, target, '', value)
        else {
            if (count !== undefined && target !== undefined){ setState(count, target, value)
            console.log('here')
            }
            else {
                if (count !== undefined) {setState(count, value) 
                console.log('here2')
                }
                else if (target !== undefined) {setState(target, value)
                console.log('here3')
                }
                else {setState(value )
                console.log('here4')
                }
            }
        }
        return true
    }
    const dateCount = multiple
        ? (Array.isArray(state) ? state.length : 0)
        : (isEmptyDate(state) ? 0 : 1)
    const newDatePickerStyle = {
        width, marginLeft, marginRight, marginTop, marginBottom,
        paddingLeft: 16,
        height: 55,
        borderRadius: 10,
        border: `1px solid ${(required && state === null) || errorBorder() ? 'var(--color-danger)' : 'var(--color-border-strong)'}`,
        backgroundColor: disabled ? 'var(--simcc-grey-150)' : 'var(--color-surface)',
        color: disabled && '#FFF',
        fontSize: state !== null ? 18 : 28
    }
    const newDatePickerAttributes = {
        value: state,
        onChange: e => {
            if (!onChangeState(e)) return
            if (Change) Change()
        },
        format: 'DD/MM/YYYY',
        placeholder: '--/--/----',
        style: newDatePickerStyle,
        disabled: disabled,
        editable: false,
        plugins: allowEmpty && [<DatePanel removeButton={dateCount > 1} />],
        range
    }
    if (multiple) {
        newDatePickerAttributes.multiple = true
        newDatePickerAttributes.sort = true
        newDatePickerAttributes.plugins = [<DatePanel removeButton={dateCount > 1} />]
    }
    if (minDate) newDatePickerAttributes.minDate = minDate.setHours(0, 0, 0, 0)
    if (maxDate) newDatePickerAttributes.maxDate = maxDate.setHours(0, 0, 0, 0)
    return <DatePicker {...newDatePickerAttributes} />
}